export default "__VITE_ASSET__fb47e1e3__"